<template>
  <v-list-item @click="open">
    <v-list-item-avatar>
      <v-icon small color="secondary">fal fa-plus</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title class="secondary--text">渡航歴を追加する</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action class="text-xs-right">
      <v-btn text :disabled="true"></v-btn>
    </v-list-item-action>
    <v-dialog v-model="config.status.active" max-width="600" scrollable>
      <v-card>
        <v-card-title class="primary amber blue-grey--text text--darken-4">
          <span class="headline">渡航歴を追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-row dense>
                <v-col cols="12" class="px-3">
                  <v-select
                    v-model="form.country"
                    label="渡航先の国"
                    item-text="label"
                    item-value="code"
                    :rules="rules.country"
                    :items="getNationItems"
                  />
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-text-field
                    v-model="form.city"
                    label="都市"
                  />
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-select
                    v-model="form.type"
                    label="渡航目的"
                    item-text="text"
                    item-value="value"
                    :rules="rules.type"
                    :items="getTypeItems"
                  />
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-text-field
                    v-model="printFormatedDepart"
                    maxlength="30"
                    append-icon="fal fa-calendar-alt"
                    @click:append="datepick"
                    label="渡航日"
                  />
                  <v-dialog v-model="config.datepicker.depart.status" max-width="290">
                    <v-date-picker
                      v-model="config.datepicker.depart.data"
                      color="amber"
                      locale="ja"
                      :day-format="date => new Date(date).getUTCDate()"
                      @input="datepicked"
                    />
                  </v-dialog>
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-text-field
                    v-model="form.term"
                    label="期間"
                    maxlength="20"
                  />
                </v-col>
                <v-col cols="12" class="px-3">
                  <v-text-field counter
                    v-model="form.note"
                    label="備考欄"
                    maxlength="50"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text
            color="secondary"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="secondary"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-item>
</template>

<script>
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        },
        datepicker: {
          depart: {
            data: '',
            status: false
          }
        }
      },
      rules: {
        country: [
          v => !!v || '必須項目です'
        ],
        type: [
          v => !!v || '必須項目です'
        ],
        depart: [
          v => !!v || '必須項目です'
        ]
      },
      form: {
        valid: true,
        status: 'DONE',
        country: '',
        city: '',
        type: '',
        depart: '',
        term: '',
        note: ''
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        status: 'DONE',
        country: '',
        city: '',
        type: '',
        depart: '',
        term: '',
        note: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'about/insert/meta', {
            cid: this.$route.params.id,
            mtype: 'about.travel',
            form: this.form
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'insert',
                data: {
                  type: 'travels',
                  resolve: res.data.data
                }
              })
            }
            this.$set(this.config.status, 'loading', false)
            this.$set(this.config.status, 'active', false)
          })
        })
      }
    },
    datepick: function () {
      if (this.form.depart.split('-').filter(it => isFinite(it)).length === 3) {
        this.$set(this.config.datepicker.depart, 'data', this.form.depart)
      }
      this.$set(this.config.datepicker.depart, 'status', true)
    },
    datepicked: function () {
      this.$set(this.form, 'depart', this.config.datepicker.depart.data)
      this.$set(this.config.datepicker.depart, 'status', false)
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    printFormatedDepart: {
      get: function () {
        if (this.form && this.form.depart) {
          return (
            this.form.depart.split('-').filter(it => isFinite(it)).length === 3
          ) ? this.$moment(this.form.depart).format('YYYY/MM/DD') : this.form.depart
        } else {
          return ''
        }
      },
      set: function (newValue) {
        this.$set(this.form, 'depart', newValue)
      }
    },
    getStatusItems () {
      return this.$mango.about.visa.status
    },
    getNationItems () {
      return Object.keys(this.$mango.nations).filter(key => { return key !== 'JP' }).map(key => {
        return {
          code: key,
          label: this.$mango.nations[key]
        }
      }).concat([{
        code: '?',
        label: '該当する国がないので備考欄に入力する'
      }])
    },
    getTypeItems () {
      return Object.keys(this.$mango.about.visa.types).map(key => {
        return {
          value: key,
          text: this.$mango.about.visa.types[key]
        }
      })
    }
  }
}
</script>
